import { countryBelongsToEurope } from '@freighthub/reference-master-data'

import { BookingDTOTransportType, WaypointBaseDTOTransportMode } from '@/clients/booking'
import { isCountryEU } from '@/features/bookings/utils/euCountryCodes'

/**
 * A shipment is Sea-FCL when the load type is FCL and the single main-carriage mode is Sea.
 * Accepts the wizard's `mainCarriageMode` array as well as single-string modes; the transport
 * enum values are the same lowercase strings across the DTO/domain type systems.
 */
export const isSeaFcl = (transportType: string | undefined, transportMode: string | string[] | undefined): boolean => {
  const modes = Array.isArray(transportMode) ? transportMode : transportMode ? [transportMode] : []
  return (
    transportType === BookingDTOTransportType.Fcl && modes.length === 1 && modes[0] === WaypointBaseDTOTransportMode.Sea
  )
}

const FORTO_ASIA_COUNTRIES = ['CN', 'VN']

/**
 * Origins where Forto runs origin operations, mirroring `isFortoFacilityCountry` in booking-v2-core.
 * VGM Submission is only performed on these origins.
 */
export const isFortoOriginCountry = (countryCode: string | undefined): boolean => {
  // countryBelongsToEurope throws on a missing country code
  if (!countryCode) return false

  const normalizedCountryCode = countryCode.toUpperCase()

  return countryBelongsToEurope(normalizedCountryCode) || FORTO_ASIA_COUNTRIES.includes(normalizedCountryCode)
}

/**
 * Legacy VGM switch gating, used while the VGM local handling flag is off.
 * Remove together with the flag in TTP-7414.
 */
export const isVGMApplicable = (
  transportMode: WaypointBaseDTOTransportMode[],
  transportType: BookingDTOTransportType,
  originCountryCode: string | undefined
) => isCountryEU(originCountryCode) && isSeaFcl(transportType, transportMode)

export const isBCNApplicable = (
  transportMode: WaypointBaseDTOTransportMode[],
  transportType: BookingDTOTransportType,
  originCountryCode: string | undefined
) => {
  const isBCNApplicableToOrigin = ['CN', 'VN', 'BD', 'HK'].includes(originCountryCode || '')

  return isBCNApplicableToOrigin && isSeaFcl(transportType, transportMode)
}
